const Professions = [
  { value: 'AT-Arts Therapist', label: 'Arts Therapist' },
  { value: 'AUD-Audiology', label: 'Audiologist' },
  { value: 'BK-Biokineticists', label: 'Biokineticist' },
  { value: 'CH-Chiropodists', label: 'Chiropodist' },
  { value: 'OT-Occupational Therapy', label: 'Occupational Therapist' },
  { value: 'OG-Orthopaedics', label: 'Orthopaedist' },
  { value: 'MR-Maintenance Register', label: 'Maintenance Register' },
  { value: 'MT-Massage Therapists', label: 'Massage Therapist' },
  { value: 'NR-Neuromuscular Therapist', label: 'Neuromuscular Therapist' },
  { value: 'OTT-Occupational Therapists Trainee', label: 'Occupational Therapist Trainee' },
  { value: 'PH-Physiotherapy', label: 'Physiotherapist' },
  { value: 'PHT-Physiotherapist Trainee', label: 'Physiotherapist Trainee' },
  { value: 'PD-Podiatry', label: 'Podiatist' },
  { value: 'RTR-Rehab Technicians Trainee', label: 'Rehab Technician Trainee' },
  { value: 'RT-Rehabilitation Technician', label: 'Rehabilitation Technician' },
  { value: 'SP-Speech Pathology', label: 'Speech Pathologist' },
  { value: 'ST-Speech Therapist', label: 'Speech Therapist' },
  { value: 'SPS-Sports Scientist', label: 'Sports Scientist' },
  { value: 'SPT-Sports Therapists', label: 'Sports Therapists' },
  { value: 'STA-Speech and Audiology Therapist', label: 'Speech and Audiology Therapist' },
  { value: 'WR-Work Rehabilitation', label: 'Work Rehabilitation' }
];

export default Professions;
